@if (!isTableView) {
<div class="loren-metric">
  <div class="loren-metric-container">
    <div
      class="loren-metric-header"
      [ngClass]="{ 'sr-only': kind() === metricCategories.TRACKING }">
      <div class="loren-metric-title">
        <h4 class="loren-metric-name" [matTooltip]="title()">
            {{ metric.description || defaultDescription() }}
        </h4>
          <div class="loren-metric-subtitle">
              {{ title() }}
          </div>
      </div>
      <button 
        class="loren-metric-button" 
        [matTooltip]="'tooltips.last_24_hour_report' | transloco"
        (click)="handleHistoryClick()">
        <mat-icon class="loren-metric-history">history</mat-icon>
      </button>
    </div>
    @if(kind() !== metricCategories.TRACKING) {
    <div class="loren-metric-content">
      @if(valueLabel() !== null && valueLabel() !== undefined) {
      <div>
        <span
          class="loren-metric-value"
          [ngClass]="{
            'loren-metric-value--long':
              kind() !== metricCategories.NUMERIC &&
              kind() !== metricCategories.PRESENCE_SENSOR
          }"
          >
            @let finalValue = this.valueLabel() | lorenNumber : (metric.type === metricTypes.TEMPERATURE_SENSOR ? 1 : 2);
            <span [innerHTML]="finalValue"></span>
            {{ metric.type === metricTypes.TEMPERATURE_SENSOR ? "°" : "" }}
        </span>
        <span class="loren-metric-unit" [innerHTML]="unit()"></span>
      </div>
      } @else {<span class="loren-metric-value--long">{{
        "asset.no_data" | transloco
      }}</span
      >}
      <mat-icon class="loren-metric-icon" [class.active]="iconActive()" [svgIcon]="icon()" />
    </div>
    } @if(kind() === metricCategories.TRACKING) {
    <div class="loren-metric-content">
      <button
        class="loren-metric-button loren-metric-button--tracking"
        [matTooltip]="'tooltips.last_24_hour_report' | transloco"
        (click)="handleHistoryClick()">
        <mat-icon class="loren-metric-history">history</mat-icon>
      </button>
      <loren-base-map
        class="loren-metric-map"
        [rounded]="true"
        [mapHeight]="140"
        [markerImage]="avatar | lorenImage | async"
        [location]="valueLabel()"
        (markerClick)="navigateToMarker()" />
    </div>
    }
  </div>

    <div class="footer">
        <div class="last-updated">
            <span>{{ "asset.updated" | transloco }}:</span>
            @if(time()) {
                <time>{{ time() | lorenDate }}</time>
            } @else {
                <span>{{"asset.no_data" | transloco}}</span>
            }
        </div>

        <div class="status">
            <battery-level [deviceId]="metric.deviceId"/>
            @if (kind() === metricCategories.TRACKING) {
                <mat-icon
                        [ngClass]="{ 'loren-metric-location-on': hasGPSCovering(), 'loren-metric-location-off': !hasGPSCovering() }"
                        [matTooltip]="(hasGPSCovering() ? 'dashboard.gps_data_reliable' : 'dashboard.gps_data_not_reliable') | transloco"
                >
                    {{ hasGPSCovering() ? "share_location" : "gps_off" }}
                </mat-icon>
            }
        </div>
    </div>
</div>
} @else {
<div class="loren-metric-table">
  <div class="loren-metric-table-icon-container">
    <button 
      class="loren-metric-button" 
      [matTooltip]="'tooltips.last_24_hour_report' | transloco"
      (click)="handleHistoryClick()">
      <mat-icon style="margin-right: 12px" class="loren-metric-history"
        >history</mat-icon
      >
    </button>
  </div>
  <div class="loren-metric-table-item">
    {{ title() }}
  </div>
  <div class="loren-metric-table-item">
    {{ metric.description || defaultDescription() }}
  </div>
    @if(MeticConfig[metric.type]; as config) {
        <div class="loren-metric-table-item--value">
        <ng-container *ngComponentOutlet="
                config.tableComponent;
                inputs: { asset: assetRaw(), metric: metricRaw() }
            " />
        </div>
    } @else {
        <div
                class="loren-metric-table-item--value"
                [innerHTML]="
      valueLabel() === null || valueLabel() === undefined
        ? ('asset.no_data' | transloco)
        : unit()
        ? (valueLabel() | lorenNumber : 2) + ' ' + unit()
        : (valueLabel() | lorenNumber : 2)
    "></div>
    }
  <div class="loren-metric-table-item--updated">
    {{ metric.time | lorenDate }}
  </div>
  <div class="loren-metric-table-item--battery">
    <battery-level [deviceId]="metric.deviceId" />
  </div>
</div>
}
